/**
 * List of available headline images by deck
 */
const headlineImagesByDeck = {
  locationDeck: [
    'spy3.webp',
    'spy2.webp',
    'spy.webp'
  ],
  animalsDeck: [
    'animal1.webp',
  ]
};

/**
 * Gets a random headline image from the available images for a specific deck
 * @param deck The deck name to get images from
 * @returns The filename of a random headline image
 */
export const getRandomHeadlineImage = (deck: string = 'locationDeck'): string => {
  const images = headlineImagesByDeck[deck as keyof typeof headlineImagesByDeck] || headlineImagesByDeck.locationDeck;
  return images[Math.floor(Math.random() * images.length)];
};

/**
 * Gets the full path for a headline image based on the deck
 * @param imageName The filename of the headline image
 * @param deck The deck name to determine the correct path
 * @returns The full path to the image
 */
export const getHeadlineImagePath = (imageName: string, deck: string = 'locationDeck'): string => {
  if (deck === 'animalsDeck') {
    return `/imgs/animals/headline/${imageName}`;
  }
  return `/imgs/spys/${imageName}`;
}; 